import ShareFreightModal from 'externals/ShareFreightModal';
import { useClearOpenSearch } from 'hooks/openSearchTrucker/useClearOpenSearch';
import { useLastSearchedDrivers } from 'hooks/openSearchTrucker/useLastSearchedDrivers';
import { useSearchTrucker } from 'hooks/openSearchTrucker/useSearchTrucker';
import { useShareFreightModal } from 'hooks/openSearchTrucker/useShareFreightModal';
import { useTruckerSummary } from 'hooks/openSearchTrucker/useTruckerSummary';
import { useDeviceSize } from 'hooks/useDeviceSize';
import { useGetElementWidth } from 'hooks/useGetElementWidth';
import { useGetTruckerQueriesData } from 'hooks/useGetTruckerQueriesData';
import { useOpenSearchContext } from 'hooks/useOpenSearchContext';
import { useOutsideClick } from 'hooks/useOutsideClick';
import LazyProfileDrawer from 'lazy-profile-drawer';
import React, { RefObject, useEffect, useRef } from 'react';
import DesktopSearchTrucker from '../Desktop';
import InputSearchTrucker from '../InputSearchTrucker';
import LastSearchedDrivers from '../LastSearchedDrivers';
import MobileSearchTrucker from '../Mobile';
import * as Styled from './styled';
import { ICardSearch } from './types';

export const OpenSearchContent = ({ outsideRefs }: ICardSearch) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const { contactListFeatureData } = useGetTruckerQueriesData();

  const {
    isProfileVisible,
    isModalJourneyVisible,
    truckerId,
    isLastSearchedDriversVisible,
    isTextFieldFocus,
    isCardVisible,
    inputHasError,
    setOpenSearchWidth,
  } = useOpenSearchContext();

  const { propsShareFreight } = useShareFreightModal();
  const { propsLastSearchedDrivers } = useLastSearchedDrivers();
  const { clearOpenSearch } = useClearOpenSearch();
  const { propsTruckerSummary } = useTruckerSummary();

  const { elementWidth: openSearchWidth } = useGetElementWidth(contentRef);

  const desktopOpenSearchMinWidth = 400;

  const showLastSearchedDrivers =
    isLastSearchedDriversVisible &&
    !!propsLastSearchedDrivers.lastSearchedDrivers?.length &&
    !inputHasError &&
    !isCardVisible;
  const showOverlay = isTextFieldFocus || isCardVisible || isLastSearchedDriversVisible;
  const showMobileCard = openSearchWidth < desktopOpenSearchMinWidth && isCardVisible;
  const showDesktopCard = openSearchWidth >= desktopOpenSearchMinWidth && isCardVisible;

  useDeviceSize(true);
  useSearchTrucker();

  useOutsideClick([...outsideRefs, contentRef as RefObject<HTMLElement>], clearOpenSearch, !isModalJourneyVisible);

  useEffect(() => {
    const body = document.querySelector('body');
    if (isProfileVisible) {
      body.style.overflow = 'hidden';
      return;
    }

    body.style.overflowX = 'hidden';
    body.style.overflowY = 'unset';
  }, [isProfileVisible]);

  useEffect(() => {
    setOpenSearchWidth(openSearchWidth);
  }, [openSearchWidth]);

  return (
    <>
      <Styled.WrapperMainSearchTrucker ref={contentRef}>
        <InputSearchTrucker />
        {showDesktopCard && <DesktopSearchTrucker />}
        {showMobileCard && <MobileSearchTrucker />}
        {showLastSearchedDrivers && <LastSearchedDrivers {...propsLastSearchedDrivers} />}
        {showOverlay && <Styled.Overlay data-testid="open-search-overlay" onClick={clearOpenSearch} />}
      </Styled.WrapperMainSearchTrucker>

      {propsShareFreight.isOpen && (
        <ShareFreightModal
          showShareFreightButton
          isShareButtonLoading={propsShareFreight.isShareButtonLoading}
          isOpen={propsShareFreight.isOpen}
          onFreightSelect={propsShareFreight.onFreightSelect}
          onClose={propsShareFreight.onClose}
          onShare={propsShareFreight.onShare}
          portalName="portal-search-trucker"
        />
      )}

      {isProfileVisible && (
        <LazyProfileDrawer
          onClose={clearOpenSearch}
          isOpen={isProfileVisible}
          data={{
            truckerId: truckerId || propsTruckerSummary?.searchedTrucker?.trucker?.id,
            portalName: 'portal-search-trucker',
            eventsSource: 'BA_home',
            isOpenSearch: true,
            truckerSearchedBy: propsTruckerSummary?.searchedTrucker?.wasSearchedByCpf ? 'cpf' : 'telefone',
            initialTruckerData: propsTruckerSummary?.searchedTrucker,
            initialContactListFeatureData: contactListFeatureData,
          }}
          withToastProvider={false}
          hideDrawerToasts
        />
      )}
    </>
  );
};

export default OpenSearchContent;
